module.exports = __webpack_public_path__ + "static/media/27.9bd3fc05.png";